<mat-selection-list
  #presetsSelectionList
  disableRipple="true"
  class="listPresets"
  [formControl]="control"
  (selectionChange)="selectionChange.emit($event)"
>
  <h3 matSubheader>
    <button
      class="help pendo-help-button"
      mat-button
      matTooltip="Help"
      matTooltipPosition="below"
    >
      <mat-icon (click)="openManual()">help</mat-icon>
    </button>
    <span class="first-column-header">Filters</span>

    <button
      mat-button
      matTooltip="Create filter"
      matTooltipPosition="below"
      id="save-filter-button"
    >
      <mat-icon (click)="save.emit()">add</mat-icon>
    </button>
  </h3>
  <mat-list-option
    *ngFor="let preset of presets"
    [value]="preset.value"
    (click)="$event.stopPropagation()"
    class="pendo-preset-option"
    [class.active]="preset.label === activeFilter"
  >
    <div
      class="filter-preset"
      (mouseenter)="onMouseEnter(preset)"
      (mouseleave)="onMouseLeave(preset)"
    >
      <div class="filter-text">
        <span *ngIf="preset.label === 'Default'">{{ preset.label }}</span>
        <span *ngIf="preset.label !== 'Default'">{{ preset.label }}</span>
      </div>
      <div class="filter-actions">
        <mat-icon
          *ngIf="preset.label === 'Default'"
          [class.hidden]="idCustomDefault === undefined || !preset.visible"
          (click)="$event.stopPropagation(); resetDefault.emit()"
          matTooltip="Reset default filter"
          id="delete-default-filter-button"
          >delete_forever</mat-icon
        >
        <mat-icon
          *ngIf="
            preset.label !== 'Default' &&
            preset.label !== 'E events' &&
            preset.label !== 'S events' &&
            preset.label !== 'G events'
          "
          id="delete-filter-button"
          [class.hidden]="!preset.visible || preset.label === nameCustomDefault"
          (click)="$event.stopPropagation(); deletePreset.emit(preset)"
          matTooltip="Delete filter"
          >delete_forever</mat-icon
        >
        <mat-icon
          *ngIf="preset.label !== 'Default'"
          id="set-default-filter-button"
          [class.hidden]="!preset.visible || preset.label === nameCustomDefault"
          (click)="$event.stopPropagation(); setDefault.emit(preset)"
          matTooltip="Set as a default filter"
          >star_border</mat-icon
        >
        <mat-icon
          *ngIf="preset.label !== 'Default'"
          [class.hidden]="preset.label !== nameCustomDefault"
          (click)="$event.stopPropagation(); resetDefault.emit()"
          matTooltip="Remove from default filter"
          id="remove-default-filter-button"
          >star</mat-icon
        >
      </div>
    </div>
  </mat-list-option>
</mat-selection-list>
